//Here are the functions for the job saving
import copy from "copy-text-to-clipboard";
import afUsercentricsConsentArray from "../../../Assets/afUsercentric";
import afSharePage from "../../../Assets/sharePageFunction";

(function() {
    function afSaveUnsaveAnimation(saveButtons) {
        let setTimeoutVariable;
        const successHintElement = saveButtons.querySelectorAll('.copy-success-hint-job')[0];
        successHintElement.innerHTML = "";
        clearInterval(setTimeoutVariable);
        if (saveButtons.className === "af-job-saved") {
            successHintElement.innerHTML = successHintElement.dataset.saved;
        }
        else {
            successHintElement.innerHTML = successHintElement.dataset.deleted;
        }
        successHintElement.classList.add('show');
        setTimeoutVariable = setTimeout(() => {
            successHintElement.classList.remove('show');
            successHintElement.innerHTML = "";
        }, 3000)
    }
    //Showing info-text after a job is saved
    document.addEventListener('DOMContentLoaded', () => {
        const saveButtons = document.getElementById('af-job-page-save-job-id');
        const saveButtonMobile = document.getElementById('af-job-page-mobile-save-job');
        //const successHintElement = document.querySelector('.copy-success-hint-job');
        saveButtons.addEventListener('click', function () {afSaveUnsaveAnimation(saveButtons)})
        saveButtonMobile.addEventListener('click', function () {afSaveUnsaveAnimation(saveButtonMobile)})
    })
    //Placing history.back() instead of link in case the previous page comes from the website
    function afGiveHistoryBack() {
        if (document.querySelectorAll('.jobdetailpage .job-breadcrumb a').length > 0) {
            const backToSearch = document.querySelectorAll('.jobdetailpage .job-breadcrumb a')[0]
            const previousPage = document.referrer;
            //const domain = window.location.protocol + "//" + window.location.hostname;
            if (previousPage.indexOf("projektsuche") > -1) {
                backToSearch.href = "javascript:history.back()";
                backToSearch.innerHTML = "Zur Projektsuche"
            }
        }
    }
    window.addEventListener('load',afGiveHistoryBack);

    //Returning IDs of the saved jobs
    function afReturnSavedJobsIDsFromLocalStorage() {
        const emptyArray = [];
        if (typeof (Storage) !== "undefined" && localStorage.getItem("afSavedJobs")) {
            const localStorageState = localStorage.getItem("afSavedJobs");
            const savedJobsLocalStorage = JSON.parse(localStorageState).length > 0 ? JSON.parse(localStorageState) : emptyArray;
            const savedJobsLocalStorageLength = savedJobsLocalStorage.length;
            let savedJobsTemp = [];
            for (let i = 0; i < savedJobsLocalStorageLength; i++) {
                if (Object.hasOwn(savedJobsLocalStorage[i], 'uid')) {
                    savedJobsTemp.push(savedJobsLocalStorage[i].uid);
                } else {
                    savedJobsTemp.push(savedJobsLocalStorage[i]);
                }
            }
            localStorage.setItem("afSavedJobs",JSON.stringify(savedJobsTemp));
            return savedJobsTemp;
        }
        else {
            return emptyArray;
        }
    }

    //Setting saved job status on load
    function settingSavedJobStatusOnLoad() {
        setTimeout(function() {
            const savedJobs = afReturnSavedJobsIDsFromLocalStorage();
            const jobId = document.querySelectorAll(".job-detail-ref-id")[0].dataset.jobId;
            if(Number(jobId)) {
                const jobID = Number(jobId);
                const saveJobButton = document.getElementById('af-job-page-save-job-id');
                const saveJobButtonMobile = document.getElementById('af-job-page-mobile-save-job');
                if(savedJobs.indexOf(jobID) > -1) {
                    saveJobButton.className = "af-job-saved";
                    saveJobButtonMobile.className = "af-job-saved";
                }
                else {
                    saveJobButton.className = "af-job-not-saved";
                    saveJobButtonMobile.className = "af-job-not-saved";
                }
            }
        },800);
    }
    window.addEventListener('load',settingSavedJobStatusOnLoad);

    //Saved jobs' indications
    function afSavedJobsIndications(savedJobsListToggler,savedJobs) {
        if(savedJobs.length > 0) {
            savedJobsListToggler.className = savedJobsListToggler.className.indexOf("af-menu-item-pwa-change") === -1 ? "af-menu-item-pwa af-menu-item-pwa-normal af-menu-item-pwa-change" : "af-menu-item-pwa af-menu-item-pwa-normal";
        }
        else {
            savedJobsListToggler.className = "";
        }
    }

    function saveUnsaveJob(button1,button2,savedJobsListToggler) {
        const jobId = document.querySelectorAll(".job-detail-ref-id")[0].dataset.jobId;
        if(Number(jobId)) {
            const jobID = Number(jobId);
            let savedJobs = afReturnSavedJobsIDsFromLocalStorage();
            const saveButton = button1;
            if (saveButton.className === "af-job-not-saved") {
                //Save job
                saveButton.className = "af-job-saved";
                button2.className = "af-job-saved";
                savedJobs.push(jobID);
                localStorage.setItem("afSavedJobs",JSON.stringify(savedJobs));
            }
            else {
                //Unsave job
                saveButton.className = "af-job-not-saved";
                button2.className = "af-job-not-saved";
                savedJobs = savedJobs.filter(job => (job !== jobID));
                localStorage.setItem("afSavedJobs",JSON.stringify(savedJobs));
            }
            afSavedJobsIndications(savedJobsListToggler.parentElement,savedJobs)
        }
    }

    const savedJobsListToggler = document.querySelectorAll("#af-menu-pwa li button")[0];
    const saveButton = document.getElementById('af-job-page-save-job-id');
    const saveButtonMobile = document.getElementById('af-job-page-mobile-save-job');
    saveButton.addEventListener('click',function() {saveUnsaveJob(saveButton,saveButtonMobile,savedJobsListToggler);});
    saveButtonMobile.addEventListener('click',function () {saveUnsaveJob(saveButtonMobile,saveButton,savedJobsListToggler);});

    //Sharing button - start
    const shareButtonMobile = document.querySelectorAll(".af-job-page-mobile-intro-button-share")[0];
    const shareTitle = document.querySelectorAll("#af-job-page-mobile-intro-text h1")[0];

    window.addEventListener("load",function() {afSharePage(shareButtonMobile,shareTitle)})
    //Sharing button - end

    //Giving different URL to back to overview page for the projects in PWA - start
    function afGiveDifferentUrlToBackToOverviewPageForProjects() {
        //Back to - button
        const backToUrl = document.querySelectorAll("#af-job-page-mobile .af-job-page-mobile-intro-button-back-to")[0];
        if(backToUrl && window.innerWidth < 768 && window.matchMedia('(display-mode: standalone)').matches && backToUrl.dataset.pwaHref) {
            backToUrl.href = backToUrl.dataset.pwaHref
        }
    }

    window.addEventListener("load",afGiveDifferentUrlToBackToOverviewPageForProjects)
    //Giving different URL to back to overview page for the projects in PWA - end
})();
